import { Link } from "react-router-dom";
import "./Footer.css";

function Footer() {
  return (
    <div>
      <div className="footer">
        <div className="content">
          <div className="box">
            <div className="first">
              <a href="#/" className="logo">
                Comfort<span>Limo.</span>
              </a>
              <ul>
                <Link to={"/"}>
                  <li>Book Limo</li>
                </Link>
                <Link to={"/services"}>
                  <li>Our Services</li>
                </Link>
                <Link to={"/fleet"}>
                  <li>Our Fleet</li>
                </Link>
                <Link to={"/about"}>
                  <li>About</li>
                </Link>
              </ul>
              <ul>
                <Link to={"/FAQ"}>
                  <li>FAQ</li>
                </Link>
                <Link to={"/contact"}>
                  <li>Contact Us</li>
                </Link>
                <Link to={"/terms"}>
                  <li>Terms & Conditions</li>
                </Link>
                <Link to={"/"}>
                  <li>Book Limo</li>
                </Link>
              </ul>
            </div>
            <div className="second">
              <p>
                Explore <span>@comfortlimo</span> on instagram
              </p>
              <div className="boxes">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
          </div>
          <div className="bottom">
            <div className="copy">
              <p>Copyrights © 2023 - 2024 comfort-limo.com</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
